import { render } from "./SectionPaymentLiquidation.vue?vue&type=template&id=4485ad74&scoped=true"
import script from "./SectionPaymentLiquidation.vue?vue&type=script&lang=js"
export * from "./SectionPaymentLiquidation.vue?vue&type=script&lang=js"

import "./SectionPaymentLiquidation.vue?vue&type=style&index=0&id=4485ad74&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4485ad74"]])

export default __exports__